import { useContext, useEffect, useState, useRef, useCallback, dangerouslySetInnerHTML } from 'react';
import { FeatureContext } from '../model/FeatureProvider';
import { getStateName, getCountyName } from '../model/StaticVariables';
import DragContainer from './DragContainer';

const SVItitle = (props) => {
    const { feature } = props;
    if (!feature || !feature.get('FIPS')) return null;
    const fips = feature.get('FIPS');
    const geolevel = String(fips).length === 5 ? 'county' : 'census';
    const countyName = getCountyName(fips);
    const stateName = getStateName(fips);
    /*note county json has special characters which is why we are using dangerouslysetinnerhtml*/

    return (
        <>
            <div id={`feature-title`} className={`info-box-pop svi title`}>
                <>
                    <button className={`btn ${geolevel}`} tabIndex="-1">
                        {geolevel === 'census' && <span>Census Tract : {fips}, </span>}
                        <span dangerouslySetInnerHTML={{ __html: countyName }}></span>, <span>{stateName}</span>
                    </button>
                </>
            </div>
        </>
    );
};

const POItitle = (props) => {
    const { feature } = props;
    if (!feature || !feature.get('info')) return null;
    const slug = feature.get('info').slug;
    const label = feature.get('info').label;
    const count = feature.get('count');
    /*note county json has special characters which is why we are using dangerouslysetinnerhtml*/

    return (
        <>
            {count < 11 && <style>{`body{cursor:pointer`}</style>}
            <div id={`feature-title`} className={`info-box-pop svi title`}>
                <>
                    <button className={`btn poi ${slug}`} tabIndex="-1">
                        <span>
                            {label} ({count})
                        </span>
                    </button>
                </>
            </div>
        </>
    );
};
const DragArrow = (props) => {
    const { feature } = props;
    if (!feature) return null;
    const type = feature.get('FIPS') ? 'svi' : 'poi';
    var slug = '';
    if (type === 'svi') {
        slug = String(feature.get('FIPS')).length === 5 ? 'county' : 'census';
    } else {
        slug = feature.get('info').slug;
    }
    return <div className={'drag-arrow ' + slug} />;
};

const HoveredFeatureTitle = () => {
    const { hoveredFeature } = useContext(FeatureContext);
    const [offsetLeft, setOffsetLeft] = useState(0);
    const titleRef = useRef();
    const margin = 20; //allows bubble to to left or right outside bounds
    const [flip, setFlip] = useState(false);

    const handleMove = (coords, bounds) => {
        var titleBounds = titleRef.current.getBoundingClientRect();
        if (titleBounds.width) {
            const leftEdge = Math.floor(coords.x + margin - titleBounds.width / 2);
            const rightEdge = Math.floor(coords.x - margin + titleBounds.width / 2);
            const leftDiff = Math.max(0, bounds.x - leftEdge); //0 or more
            const rightDiff = Math.min(0, bounds.right - rightEdge); //0 or less
            setOffsetLeft(leftDiff || rightDiff);
        } else {
            setOffsetLeft(0);
        }
        const halfwayDown = coords.y > bounds.height / 2 + bounds.y; //halfway point of viewport
        setFlip(halfwayDown);
    };

    return (
        <>
            <DragContainer className={'feature title centered' + (flip ? ' flip' : '')} onMove={handleMove}>
                <DragArrow feature={hoveredFeature} />
                <div ref={titleRef} className={'title-container'} style={{ left: offsetLeft }}>
                    <SVItitle feature={hoveredFeature} />
                    <POItitle feature={hoveredFeature} />
                </div>
            </DragContainer>
        </>
    );
};
export { HoveredFeatureTitle };

// const FeatureTitle = (props) => {
//     const { theme, tract } = useContext(InterfaceContext);
//     const { id, visible, feature, pixelCoords, onClose } = props;
//     const [statename, setStateName] = useState('');
//     const [countyname, setCountyName] = useState('');
//     const [fips, setFips] = useState('');

//     const getFeatureFips = () => {
//         if (!feature) return '';
//         return feature.get('FIPS') || '';
//     };
//     const getFullStateName = () => {
//         if (!fips) return '';
//         let stateFips = String(fips).substring(0, 2);
//         return statesList.find((st) => {
//             return st.id + '' === stateFips;
//         }).label;
//     };
//     const getCountyName = async () => {
//         if (!fips) return;
//         let countFips = String(fips).substring(0, 5);
//         const counties = countiesList;
//         return (
//             counties.find((cnt) => {
//                 return cnt.cc + '' == countFips || cnt.CC + '' == countFips;
//             })?.CN || ''
//         );
//     };

//     useEffect(async () => {
//         if (!feature) return;
//         let fipsNum = getFeatureFips(feature);
//         setFips(fipsNum);
//     }, [feature, visible, theme]);

//     useEffect(async () => {
//         if (!fips) return;

//         let stateNM = getFullStateName();
//         let countyNM = await getCountyName();

//         setStateName(stateNM);
//         setCountyName(countyNM);
//     }, [fips]);

//     var modalCoords = [pixelCoords[0], pixelCoords[1]];
//     var arrowX = pixelCoords[2];
//     var flip = pixelCoords[3] ? 'flip' : '';
//     const censusTitle = useCallback(() => {
//         if (tract !== 'census') return;
//         return (
//             <>
//                 <span>
//                     {tract === 'census' ? 'Census Tract' : 'County'} {fips},
//                 </span>
//             </>
//         );
//     }, [tract, fips]);

//     return (
//         <>
//             <div id={`feature-${id}`} className={`info-box-pop title ${visible ? 'show' : ''}`}>
//                 {feature && feature?.get('data')?.length < 11 && <style>{`body{cursor:pointer`}</style>}
//                 <Modal pixelCoords={modalCoords} visible={visible} pinned={false} onClose={onClose} divWindow={true}>
//                     {(feature && feature.get('poi') && (
//                         <>
//                             <span className={`arrow poi ${feature.get('info').slug} ${flip}`} style={{ left: arrowX, display: visible ? 'block' : 'none' }}>
//                                 <span className="inner"></span>
//                             </span>
//                             <button className={`btn poi ${feature.get('info').slug}`} tabIndex="-1">
//                                 <span>
//                                     {feature.get('info')?.label} ({feature.get('count')})
//                                 </span>
//                             </button>
//                         </>
//                     )) || (
//                         <>
//                             <span className={`arrow ${fips.length > 5 ? 'census' : 'county'}  ${flip}`} style={{ left: arrowX, display: visible ? 'block' : 'none' }}>
//                                 <span className="inner"></span>
//                             </span>
//                             <button className={`btn ${fips.length > 5 ? 'census' : 'county'}`} tabIndex="-1">
//                                 {censusTitle()} <span dangerouslySetInnerHTML={{ __html: countyname }}></span>, <span>{statename}</span>
//                             </button>
//                         </>
//                     )}
//                 </Modal>
//             </div>
//         </>
//     );
// };
// export { FeatureTitle };

// const Backup_HoveredFeatureTitle = () => {
//     const { scope, usState, selectedFeatureIsPinned: pinned } = useContext(InterfaceContext);
//     const { hoveredFeature } = useContext(InterfaceContext);
//     //@@ __for testing__
//     // const [visible, setVisible] = useState(false);
//     var visible = true;
//     var setVisible = () => {};
//     //@@ __
//     const [localCoods, setLocalCoords] = useState([0, 0, 0]);
//     const [localFeature, setLocalFeature] = useState(false);
//     const featureRef = useRef();

//     const mousemove = (e) => {
//         if (!document) return;
//         const tabContent = document.querySelector('#tab-content');
//         const bounds = tabContent?.getBoundingClientRect();
//         if (!bounds) return;
//         const mouseOverMap = e.target.closest('#tab-content');
//         if (!mouseOverMap) return;
//         let mousex = e.pageX;
//         let mousey = e.pageY;
//         let mapx = bounds.x + window.scrollX;
//         let mapy = bounds.y + window.scrollY;
//         let relativex = Math.floor(mousex - mapx);
//         let relativey = Math.floor(mousey - mapy);
//         poseWindow([relativex, relativey]);
//     };

//     useEffect(() => {
//         setLocalFeature(hoveredFeature);
//     }, [hoveredFeature, scope]);

//     const validateFeature = (feature) => {
//         if (!feature) return false;
//         const fips = feature?.get('FIPS') || '';
//         if (feature.get('poi')) return true;
//         if (scope === 'state' && usState?.id !== fips?.substring(0, 2)) {
//             return false;
//         }
//         return true;
//     };

//     const getMaxDraggingBounds = (m = 0) => {
//         if (!featureRef.current) return;
//         const tabContent = document.querySelector('#tab-content');
//         const modal = featureRef.current.querySelector('.modal-win');
//         let h = tabContent.offsetHeight; //for reference
//         let b = tabContent.offsetHeight - modal.offsetHeight; //largest(down) y value possible without getting cropped

//         let w = tabContent.offsetWidth;
//         let r = tabContent.offsetWidth - modal.offsetWidth;

//         let t = 0; //minimum y value without getting cropped
//         let l = 0;

//         return { top: t + m, left: l + m, right: r - m, bottom: b - m };
//     };
//     const poseWindow = (pixelCoords) => {
//         const margin = 10;
//         // const tabContent = document.querySelector('#tab-content');
//         const modal = featureRef.current.querySelector('.modal-win');
//         let arrow = featureRef.current.querySelector('.modal-win .inner');
//         let button = modal.querySelector('button');
//         var boundary = getMaxDraggingBounds(margin);
//         let yhalfway = (boundary.bottom - boundary.top) / 2 + boundary.top;
//         let yOffset = arrow.offsetHeight / 2; //arrow.offsetHeight - arrow.offsetHeight / 2;
//         let xOffset = modal.offsetWidth / 2;

//         let x = pixelCoords[0] - xOffset;
//         let y = pixelCoords[1] + yOffset;
//         let flip = 0;
//         let buttonX = Math.max(x, 0);
//         buttonX = Math.min(buttonX, boundary.right);
//         let arrowX = xOffset;

//         let rightMax = boundary.right - modal.offsetWidth / 2; //width of bounds - 1/2 width of bubble
//         if (buttonX === 0) {
//             arrowX = Math.max(pixelCoords[0], 0);
//         }
//         if (buttonX > rightMax) {
//             arrowX = Math.min(pixelCoords[0] - buttonX, boundary.right);
//         }
//         //ΔVΔVΔ: minimum left should be 0, x offset should take diff between
//         if (y > yhalfway) {
//             let halfwayy = button.offsetHeight + yOffset + 10;
//             flip = 1;
//             y = pixelCoords[1] - halfwayy;
//         }
//         setLocalCoords([buttonX, y, arrowX, flip]);
//     };
//     useEffect(() => {
//         setVisible(validateFeature(hoveredFeature));
//     }, [hoveredFeature]);
//     useEffect(() => {
//         window.addEventListener('mousemove', mousemove);
//         return () => {
//             window.removeEventListener('mousemove', mousemove);
//         };
//     }, []);

//     return (
//         <div className="title hovered-window" ref={featureRef}>
//             <FeatureTitle id="title" visible={!pinned && visible} pinned={pinned} feature={localFeature} pixelCoords={localCoods} />
//         </div>
//     );
// };
// export { HoveredFeatureTitle };
